export const AlgoliaFacets = {
  Q: 'q',
  Page: 'page',
  Brand: 'brand',
  Category: 'category',
  ClothingSizeKids: 'clothingSizeKids',
  ClothingSizeMens: 'clothingSizeMens',
  ClothingSizeWildcard: 'clothingSize.*',
  ClothingSizeWomens: 'clothingSizeWomens',
  Colour: 'colour',
  ColourVariants: 'colour_variants',
  Discount: 'discount',
  FacetsWildcard: 'facets.*',
  Gender: 'gender',
  Price: 'price',
  Promotions: 'promotions',
  Rating: 'rating',
  ReviewScore: 'reviewScore',
  ReviewScoreFlattened: 'reviewScoreFlattened',
  ShoeWidth: 'shoeWidth',
  SizeClothingKids: 'sizeClothingKids',
  SizeClothingMens: 'sizeClothingMens',
  SizeClothingWomens: 'sizeClothingWomens',
  SizeShoeMens: 'sizeShoeMens',
  SizeShoeWomens: 'sizeShoeWomens',
  SizeWildcard: 'size.*',
  StoreInventory: 'storeInventory',
  Collection: 'facets.Collection',
} as const;

export const knownFacetNames = [
  'q',
  'page',
  'brand',
  'category',
  'clothingSize.*',
  'clothingSizeKids',
  'clothingSizeMens',
  'clothingSizeWomens',
  'colour',
  'discount',
  'facets.*',
  'gender',
  'price',
  'promotions',
  'reviewScore',
  'shoeWidth',
  'shopCanadian',
  'size.*',
  'sortBy',
  'sizeClothingKids',
  'sizeClothingMens',
  'sizeClothingWomens',
  'sizeShoeMens',
  'sizeShoeWomens',
  'storeInventory',
];
